import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/SmoothScroll.js
var SmoothScroll = class {
  constructor(el) {
    this.el = el;
    this.anchors = el.querySelectorAll("[data-smooth-scroll-anchor]");
    this.sectionsAry = Array.from(document.querySelectorAll("[data-smooth-scroll-target]"));
    this.underline = el.querySelector("[data-smooth-scroll-underline]");
    this.selectedIdx = 0;
    this.menuEnd = this.anchors[this.anchors.length - 1] ? this.anchors[this.anchors.length - 1].getBoundingClientRect().right : 0;
    this.scrollTo = 0;
    this.prevScrollPos = 0;
    this.context = this.el.parentElement.hasAttribute("data-pdp") ? "product" : "";
    if (this.anchors.length > 0) {
      if (this.underline.hasAttribute("data-match-width")) {
        this.underline.style.width = `${this.anchors[0].getBoundingClientRect().width}px`;
      }
      const parentRect = this.el.getBoundingClientRect();
      let idx = this.sectionsAry.findLastIndex((el2) => el2.offsetTop < document.documentElement.scrollTop + parentRect.y + parentRect.height + 100);
      if (idx < 0)
        idx = 0;
      this.underline.style.left = `${this.anchors[idx].firstElementChild.offsetLeft}px`;
      this.underline.style.width = `${this.anchors[idx].firstElementChild.getBoundingClientRect().width}px`;
      this.anchors[0].parentNode.querySelector(".active").classList.remove("active");
      this.anchors[idx].classList.add("active");
      if (window.innerWidth < 1024 && this.menuEnd >= document.documentElement.clientWidth) {
        const anchor = idx > 0 ? this.anchors[idx - 1] : this.anchors[idx];
        const elLeft = anchor.getBoundingClientRect().x - parentRect.x;
        this.el.style.left = idx > 0 ? `-${elLeft}px` : "";
      }
      this.initClickListeners();
      this.initScrollObserver();
      if (el.hasAttribute("data-under-header")) {
        this.positionEl();
        window.addEventListener("resize", () => {
          if (window.innerWidth > 1024) {
            this.el.style.left = 0;
          }
          const anchor = document.querySelector(
            `[data-smooth-scroll-anchor="${this.sectionsAry[this.selectedIdx].getAttribute(
              "data-smooth-scroll-target"
            )}"]`
          );
          this.underline.style.left = `${anchor.offsetLeft}px`;
          this.underline.style.width = `${anchor.getBoundingClientRect().width}px`;
        });
      } else {
        window.addEventListener("resize", () => {
          const anchor = document.querySelector(
            `[data-smooth-scroll-anchor="${this.sectionsAry[this.selectedIdx].getAttribute(
              "data-smooth-scroll-target"
            )}"]`
          );
          this.underline.style.left = `${anchor.offsetLeft}px`;
          this.underline.style.width = `${anchor.getBoundingClientRect().width}px`;
          this.resizeListener();
        });
        this.resizeListener();
      }
    } else {
      this.initScrollObserver();
    }
    this.underline.classList.remove("hidden");
  }
  resizeListener() {
    this.el.closest("section").style.top = "57px";
  }
  positionEl() {
    const headerHeight = document.querySelector("header").getBoundingClientRect().height;
    this.el.parentNode.style.top = `${headerHeight - 2}px`;
  }
  initClickListeners() {
    this.anchors.forEach((anchor) => {
      anchor.addEventListener("click", (el) => {
        const target = document.querySelector(
          `[data-smooth-scroll-target="${anchor.getAttribute(
            "data-smooth-scroll-anchor"
          )}"]`
        );
        const y = target.getBoundingClientRect().top + window.scrollY - 100;
        const offset = parseInt(target.getAttribute("data-smooth-scroll-offset")) | 0;
        const scrollTo = Math.trunc(y - offset);
        if (window.innerWidth >= 1024) {
          this.scrollTo = scrollTo;
          this.underline.style.left = `${el.target.offsetLeft}px`;
          this.underline.style.width = `${el.target.getBoundingClientRect().width}px`;
          const idx = this.sectionsAry.findIndex((section) => section.dataset.smoothScrollTarget === el.target.parentElement.dataset.smoothScrollAnchor);
          this.selectedIdx = idx >= 0 ? idx : 0;
        }
        window.scrollTo({
          behavior: "smooth",
          top: scrollTo
        });
      });
    });
  }
  initScrollObserver() {
    window.addEventListener("scroll", () => {
      if (!this.el.hasAttribute("data-no-hide")) {
        this.el.parentNode.classList.toggle("hidden", window.scrollY < 100);
      }
      if (this.menuEnd === 0)
        this.menuEnd = this.anchors[this.anchors.length - 1].getBoundingClientRect().right;
      const parentRect = this.el.getBoundingClientRect();
      const currScrollPos = document.documentElement.scrollTop;
      const idx = this.sectionsAry.findLastIndex((el) => el.offsetTop < currScrollPos + parentRect.y + parentRect.height + 100);
      if (idx >= 0 && idx !== this.selectedIdx) {
        if (window.innerWidth < 1024) {
          const anchor2 = idx > 0 ? this.anchors[idx - 1] : this.anchors[idx];
          const elLeft = this.menuEnd >= document.documentElement.clientWidth ? anchor2.getBoundingClientRect().x - parentRect.x : 0;
          this.el.style.left = idx > 0 ? `-${elLeft}px` : "";
        }
        if (this.scrollTo > 0) {
          if (currScrollPos > this.prevScrollPos && currScrollPos >= this.scrollTo || currScrollPos < this.prevScrollPos && currScrollPos <= this.scrollTo) {
            this.scrollTo = 0;
            this.underline.style.left = `${this.anchors[this.selectedIdx].offsetLeft}px`;
            this.underline.style.width = `${this.anchors[this.selectedIdx].getBoundingClientRect().width}px`;
          }
        } else {
          this.underline.style.left = `${this.anchors[idx].offsetLeft}px`;
          this.underline.style.width = `${this.anchors[idx].getBoundingClientRect().width}px`;
          this.selectedIdx = idx;
        }
        const anchor = idx > 0 ? this.anchors[idx - 1] : this.anchors[idx];
        if (idx >= 0) {
          this.anchors[idx].parentNode.querySelector(".active").classList.remove("active");
        }
        this.anchors[this.selectedIdx].classList.add("active");
      }
      this.prevScrollPos = document.documentElement.scrollTop;
    });
  }
};
var SmoothScroll_default = SmoothScroll;
export {
  SmoothScroll_default as default
};
